@defer (when this.initializationService.initializationComplete()) {
  <div class="grid-container" [class.show-right]="rightSidebarState.isVisible()">

    <!-- Left Sidebar Container -->
    <div class="left-sidebar-container">
      <app-left-sidebar/>
    </div>

    <main class="content"><general-system-message /><router-outlet></router-outlet></main>

    @if (showRightSplitter()) {
      <div
        class="right-splitter"
        role="separator"
        aria-orientation="vertical"
        tabindex="0"
        (pointerdown)="onSplitterPointerDown($event)"
        (pointercancel)="onSplitterResizeEnd()"
      ></div>
    }

    <!-- Right Sidebar Container -->
    <div class="right-sidebar-container">
      <app-right-sidebar/>
    </div>
  </div>
  <drawer-container/>
} @placeholder {
  <div class="placeholder">
    Loading CGI Assist...
  </div>
} @loading (after 100ms; minimum 500ms) {
  <div class="placeholder">
    <p>Fetching CGI Assist...</p>
  </div>
} @error {
  <div class="placeholder">
    <p>Failed to load CGI Assist.</p>
  </div>
}
